/**
 * Task TanStack Query key constants.
 *
 * A pure module with no side-effecting imports, mirroring `use-reporting-query-keys`
 * and `correspondence/correspondence-query-keys`. Keeping these out of
 * `use-tasks-helpers` (which imports the Supabase client) is what lets
 * `task-cache-invalidation` depend on them without an import cycle.
 */
export const TASK_QUERY_KEYS = {
  tasks: 'tasks',
  task: 'task',
  subtasks: 'subtasks',
  myTasks: 'my-tasks',
  myTasksByOrg: 'my-tasks-by-org',
  emailTasks: 'email-tasks',
} as const;
